<template>
  <div class="appchart">
    <el-empty v-if="empty" class="charts" :image-size="emptyImgSize"></el-empty>
    <div v-else :id="id" :ref="id" class="charts"></div>
  </div>
</template>

<script>
let num = 1;
import * as echarts from "echarts";
export default {
  name: "AppChart",
  props: {
    option: {
      type: Object,
      require: true,
    },
    showAutoTooltip: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    emptyImgSize: {
      type: [String, Number],
      default: 80,
    },
  },
  data() {
    return {
      id: `chart-` + num,
      chart: null,
      resizeFn: null,
    };
  },
  watch: {
    option: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!this.chart) {
          this.$nextTick(() => {
            this.init(val);
          });
        } else {
          this.updateChart(val);
        }
      },
    },
  },
  created() {
    ++num;
  },
  beforeDestroy() {
    // 销毁
    this.chartTooltip?.clearLoop();
    this.chart?.dispose();
    window.removeEventListener("resize", this.resizeFn, false);
  },
  methods: {
    // 初始化
    init(val) {
      let self = this;
      const dom = this.$refs[this.id];
      if (!dom) return;
      this.chart = echarts.init(dom);
      this.updateChart(val);
      this.resizeFn = function () {
        self.chart?.resize();
      };

      window.addEventListener("resize", this.resizeFn, false);
    },
    // 更新数据
    updateChart(val) {
      this.chart.setOption(val);
      if (this.showAutoTooltip && this.chargeData(val)) {
        this.chartTooltip?.clearLoop();
        this.chartTooltip = null;
        this.chartTooltip = window.tools.loopShowTooltip(
          this.chart,
          this.option,
          {
            loopSeries: true,
          }
        );
      }
    },
    // 判断echarts数据
    chargeData(val) {
      let count = 0;
      if (val.series) {
        val.series.map((item) => {
          if (item.data.length > 0) {
            count++;
          }
        });
        if (count == 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.appchart {
  width: 100%;
  height: 100%;
  .charts {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
}
</style>
